import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showDeviationGroupListPopup } from './redux/actionCreators';
import { getDeviationTitle } from '../DeviationViews/_helpers';
export default function useDeviationGroupListPopup(deviation) {
    var _deviation_extended, _deviation_extended1;
    const { deviationId } = deviation;
    const title = getDeviationTitle(deviation);
    const canRemoveFromGroup = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserEdit;
    const url = (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.groupListUrl;
    const dispatch = useDispatch();
    const dispatchedShowDeviationGroupListPopup = useCallback(()=>{
        dispatch(showDeviationGroupListPopup({
            deviationId,
            canRemoveFromGroup,
            title,
            url
        }));
    }, [
        dispatch,
        deviationId,
        canRemoveFromGroup,
        url,
        title
    ]);
    return dispatchedShowDeviationGroupListPopup;
}
